import { OPEN_NAV, ResetActive } from '../../actions/navitems';

export default (dispatch, { type, open }) => {
  if (type === OPEN_NAV && !open) {
    dispatch(ResetActive());
  }
};
